import { render, staticRenderFns } from "./Ingenieria.vue?vue&type=template&id=cd1df928&scoped=true&"
import script from "./Ingenieria.vue?vue&type=script&lang=js&"
export * from "./Ingenieria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1df928",
  null
  
)

export default component.exports